import classNames from "classnames";
import * as React from "react";
import { Text } from "../layout";
import * as styles from "./HyperLink.less";

type Props = {
    /** link will be rendered with default link_mixin color: #1180c7 */
    colored?: boolean;
    underlined?: boolean;
} & React.AnchorHTMLAttributes<any> &
    React.ComponentProps<typeof Text>;

export const HyperLinkClasses = styles;

export const HyperLink: React.FC<Props> = ({ children, className, colored, underlined = true, ...props }) => {
    const classes = classNames(
        colored ? styles.colored : styles.hyperlink,
        !underlined && styles.no_underline,
        className
    );

    return (
        <Text tag="a" className={classes} target="_blank" {...props}>
            {children}
        </Text>
    );
};
